import { useContext, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import _get from 'lodash/get';
import { AppContext } from 'commons-ui';

import { dehydrateFormDataForAdd, hydrateFormDataForAdd } from '../../utils/formDataParser';
import { FORM_FIELD_CONFIG, FORM_FIELD_KEYS } from '../../utils/formConfig';
import useService from '../../utils/useService';

const useAdd = () => {
	const { showAlert } = useContext(AppContext);
	const [showLoader, setShowLoader] = useState(false);
	const history = useHistory();
	const { getManagerOptions, requestAddInternalUser } = useService();
	FORM_FIELD_CONFIG[FORM_FIELD_KEYS.managerName].setRenderProps({ getOptions: getManagerOptions });
	const location = useLocation();
	let data = _get(location, ['state', 'rowData']);
	data = hydrateFormDataForAdd(data);
	const addInternalUser = async (addedData: any) => {
		const response = await requestAddInternalUser(addedData);
		if (response.data.success) {
			showAlert(`Entity added successfully`, { type: 'success' });
			history.goBack();
		} else {
			showAlert(`Failed to add entity: ${response.data.message || 'Unknown error'}`, { type: 'error' });
			history.goBack();
		}
		setShowLoader(true);
	};

	const handleFormSubmit = (submittedData: any) => {
		addInternalUser(dehydrateFormDataForAdd(submittedData));
	};

	const handleFormCancel = () => {
		history.goBack();
	};

	return { data, showLoader, handleFormSubmit, handleFormCancel, setShowLoader };
};

export default useAdd;
